import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import GoogleMapWithSearch from "../../../components/GoogleMapWithSearch";

const AddressDialog = ({ open, onClose, onAddressChange }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
      <IconButton onClick={onClose} size="small">
        <Icon icon="mdi:close" width="22" height="22" />
      </IconButton>
    </DialogTitle>

    <DialogContent>
      <GoogleMapWithSearch onAddressChange={onAddressChange} />
    </DialogContent>
  </Dialog>
);

AddressDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddressChange: PropTypes.func.isRequired,
};

export default AddressDialog;
